import React from "react";

export default function AllCaughtUp() {
  return (
    <div className="all-caught-up">
      <span className="all-caught-up-text">لقد وصلت لنهاية المشاريع المقترحة</span>
      <span className="icon-wrap">
        <i className="fa-solid fa-circle-check"></i>
      </span>
    </div>
  );
}
